import { defineNuxtRouteMiddleware, storeToRefs, computed } from '#imports';
import { useDictionariesStore } from '@/entities/Dictionary/store/dictionaries';

export default defineNuxtRouteMiddleware(async (to) => {
	const dictionariesStore = useDictionariesStore();
	const { names, selectDictionaryId, currentDictionary, dictionaryDataBySlug } = storeToRefs(dictionariesStore);
	const { getDictionariesNames, getDictionaries, getDictionaryById } = dictionariesStore;

	await Promise.allSettled([
		getDictionariesNames(),
		getDictionaries(),
	]);

	const computedDictionaryId = computed(() => {
		return selectDictionaryId.value
			?? dictionaryDataBySlug.value(to.params?.slug as string)?.id
			?? names.value[0]?.id;
	});

	currentDictionary.value = await getDictionaryById(computedDictionaryId.value);
});
